<template>
    <div class="row-12">
        <div class="col-12">
            <section class="row-12">
                <div class="col-6 col-sm-12">
                    <h3>Twój profil</h3>
                    <p>Dane wymagane do poprawnego działania. Dane tutaj zgrupowane posłużą do ogólnego opisu Twojego
                        profilu i
                        umożliwią Twoją identyfikację w naszej aplikacji.</p>
                    <form class="form-align-right m-r-5">

                        <div class="row-12 w-100">
                            <div class="col-6 col-sm-12 ">
                                <label>Imię *</label>
                                <input type="text" v-model="userProfile.firstname" placeholder="Twoje imię" autofocus
                                       required>
                            </div>
                            <div class="col-6 col-sm-12 ">
                                <label>Nazwisko *</label>
                                <input type="text" v-model="userProfile.lastname" placeholder="Twoje nazwisko" required>
                            </div>
                        </div>
                        <label>Adres email *</label>
                        <input type="email" v-model="userProfile.email" placeholder="Twoj adres email" required>
                        <label>Zdjęcie profilowe</label>
                        <div class="row-12 w-100">
                            <div class="col-6 col-sm-12 center-flex-a">
                                <div class="user-img-show">
                                    <img id='profile_img_show' :src="userProfile.profile_img" :alt="userProfile.firstname">
                                </div>
                                <div class="input-file-container">
                                    <input class="input-file" id="profile_img" type="file" accept="image/jpeg, image/png, image/gif, image/svg+xml">
                                    <label tabindex="0" for="profile_img" class="input-file-trigger">Zmień zdjęcie</label>
                                </div>
                                <p class="file-return"></p>
                            </div>
                            <div class="col-6 col-sm-12">
                                <small><b>Wymagania podczas wgrywania zdjęcia:</b></small>
                                <ul>
                                    <li>Format: <b>jpg, png, gif, svg</b></li>
                                    <li>Rozmiar: <b>maksymalnie 2mb</b></li>
                                </ul>
                            </div>
                        </div>
                        <small class="m-t-2 w-100">* pola wymagane</small>
                        <button @click.prevent="saveMain">Zapisz</button>
                    </form>


                </div>
                <div class="col-6 col-sm-12">

                    <h4>Opcje związane z profilem</h4>
                    <p>Pamiętaj jeśli tylko chcesz zawsze możesz pozbyć się swojego konta i
                        wszystkich powiązanych danych. W tym celu zaloguj się na swoje konto na stronie <a
                                href="https://centrumklubu.pl">centrumklubu.pl</a> a następnie przejdź do zakładki
                        profil.
                        Tam też możesz w pełni edytować swój profil, podstawowe funkcje dostępne tam to:</p>

                    <ul>
                        <li>
                            Zmiana hasła na nowe
                        </li>
                        <li>
                            Edycja praywatności Twoich danych.
                        </li>
                        <li>
                            Edycja podstawowych jak i rozszerzonych danych.
                        </li>
                        <li>
                            Zarządzanie dostępnymi licencjami.
                        </li>
                    </ul>
                </div>
            </section>
        </div>
        <div class="modal" id="changePasswordModal">
            <div class="modal-header">
                Zmiana hasła
            </div>
            <div class="modal-body" style="max-width: 600px">
                <p>Aby poprawnie zmienić hasło, musisz podać aktualne, a następnie dwa razy powtórzyć hasło nowe.</p>
                <label>Aktualne hasło</label>
                <input type="password" v-model="password.old" placeholder="Twoj aktualne hasło" required>
                <label>Nowe hasło</label>
                <input type="password" v-model="password.new" placeholder="Twoj nowe hasło" required>
                <label>Powtórz nowe hasło</label>
                <input type="password" v-model="password.reNew" placeholder="Twoj nowe hasło" required>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#changePasswordModal')">Anuluj</button>
                <button @click="changePassword">Zmień hasło</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MyProfile",
        data: function () {
            return {
                userProfile: {
                    firstname: "",
                    lastname: "",
                    email: "",
                    profile_img: "",
                },
                password: {
                    old: '',
                    new: '',
                    reNew: ''
                }
            }
        },
        methods: {
            saveMain() {
                try {
                    let valid = new Validator({
                        "imię": this.userProfile.firstname,
                        "nazwisko": this.userProfile.lastname,
                        "adres email": this.userProfile.email,

                    });
                    valid.get("imię").length(3, 255);
                    valid.get("nazwisko").length(3, 255);
                    valid.get("adres email").length(3, 255);

                    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                    if (!re.test(String(this.userProfile.email).toLowerCase())) {
                        notify.createNotifier("Niepoprawny adres email. Popraw go, aby zapisać zmiany.", "danger", 4000);
                        throw "Błędny format adresu email";
                    }
                } catch (e) {
                    return false;
                }

                axios.put(`user`, {
                    firstname: this.userProfile.firstname,
                    lastname: this.userProfile.lastname,
                    email: this.userProfile.email,
                    profile_img: this.userProfile.profile_img
                })
                    .then((response) => {
                        window.notify.createNotifier("Dane zapisane pomyslnie.", "success", 4000);
                        window.AuthMiddleware.user.firstname = this.userProfile.firstname;
                        window.AuthMiddleware.user.lastname = this.userProfile.lastname;
                        window.AuthMiddleware.user.email = this.userProfile.email;
                    });
            },
            changePassword() {
                try {
                    let valid = new Validator({
                        "aktualne hasło": this.password.old,
                        "nowe hasło": this.password.new,
                        "powtórzone hasło": this.password.reNew,

                    });
                    valid.get("aktualne hasło").length(5, 255);
                    valid.get("nowe hasło").length(5, 255);
                    valid.get("powtórzone hasło").length(5, 255);

                    if (this.password.new !== this.password.reNew) {
                        notify.createNotifier("Nowe hasła zostało niepoprawnie powtórzone. Spróbuj jeszcze raz.", "danger", 4000);
                        throw "Błędnie powtórzone hasło";
                    }
                } catch (e) {
                    return false;
                }

                axios.put(`user/password`, {
                    old: this.password.old,
                    new: this.password.new
                })
                    .then((response) => {
                        window.notify.createNotifier("Hasło zostało pomyślnie zmienione.", "success", 4000);
                        this.hideModal('#changePasswordModal');
                        this.password = {
                            old: '',
                            new: '',
                            reNew: ''
                        }
                    });
            }
        },
        mounted: function () {
            this.userProfile = $.extend({}, AuthMiddleware.user);
            this.userProfile.date_add = moment(this.userProfile.date_add).fromNow();


            $(document).on('change', '#profile_img', () => {
                if (!$('#profile_img')[0].files[0]) {
                    this.userProfile.profile_img = AuthMiddleware.user.profile_img;
                } else {
                    let reader = new FileReader();
                    reader.readAsDataURL($('#profile_img')[0].files[0]);
                    reader.onload = () => {
                        this.userProfile.profile_img = reader.result;
                        $('#profile_img_show').attr('src',reader.result);
                    };
                }
            });

        },
    }
</script>

<style scoped lang="scss">
    .user-img-show{
        width: 100%;
        height: 100px;

        img{
            height: 100%;
            width: auto;
            display: block;
            margin: auto;
            border-radius: 50%;
        }
    }
</style>